import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { TradableWallet as OldTradableWallet } from "@models/interfaces/tradable_wallet";
import {
	AssetWalletBase,
	AssetWalletBaseAdapter
} from "@modules/+new/wallets/domain/entities/abstract/asset-wallet-base-model";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CryptoCoinWallet extends AssetWalletBase {}

export class CryptoCoinWalletAdapter extends BaseAdapter<OldTradableWallet, CryptoCoinWallet> {
	private assetWalletBaseAdapter: AssetWalletBaseAdapter = new AssetWalletBaseAdapter();
	public constructor() {
		super();
	}
	public adapt(item: OldTradableWallet): CryptoCoinWallet {
		return this.assetWalletBaseAdapter.adapt(item);
	}
}
